module.exports = __webpack_public_path__ + "img/official_account.2a1a61fe.jpg";